/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import useStyles from './styles';

const Header = () => {
  const classes = useStyles();

  return (
    <div className="section">
      <Container maxWidth="lg">
        <Box className={classes.header}>
          <Box className={classes.headerLogo}>
            <Typography variant="h1" className={classes.appTitle}>Canadian Newsroom Diversity Survey</Typography>
          </Box>
          <Box className={classes.linkQlik}>
            <span className={classes.linkQlikText}>Analytics by</span>

            <a href="https://www.qlik.com/us/">
              <img src="assets/images/Qlik400.png" alt="Analytics by Qlik" className={classes.logoQlikAnalytics} />
            </a>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export default Header;
